import * as React from 'react';
import 'classnames';
import '@grandvisionhq/common';
import '@grandvisionhq/fun-products';
import '@grandvisionhq/state';
import '@swc/helpers';
import '@grandvisionhq/commercetools';
import '@grandvisionhq/inventory';
import '@grandvisionhq/utils';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/analytics';
import '@grandvisionhq/svc-monetate';
import '@grandvisionhq/reviews';
import { PackageQuantityDropdownContainer } from '../../../Components/PackageQuantityDropdown/PackageQuantityDropdownContainer.js';
import { mapVariantPowerItems, getSortedPowerItems } from '../../utils.js';

const PowerSelector = ({ activeSku , handleVariantPick , variants  })=>{
    var ref;
    const powerItems = React.useMemo(()=>mapVariantPowerItems(variants)
    , [
        variants
    ]);
    const sortedPowerItems = React.useMemo(()=>getSortedPowerItems(powerItems)
    , [
        powerItems
    ]);
    const selectedPower = (ref = powerItems.find((item)=>item.value === activeSku
    )) === null || ref === void 0 ? void 0 : ref.value;
    return /*#__PURE__*/ React.createElement(PackageQuantityDropdownContainer, {
        onChange: (selectedVariant)=>handleVariantPick(selectedVariant.label)
        ,
        selectedSize: selectedPower,
        items: sortedPowerItems
    });
};

export { PowerSelector };
//# sourceMappingURL=PowerSelector.js.map
